import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  PLATFORM_ID,
  inject,
  signal,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const SCROLL_THRESHOLD = 300;

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  templateUrl: './scroll-to-top.html',
  styleUrl: './scroll-to-top.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollToTop {
  private readonly destroyRef = inject(DestroyRef);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  protected readonly isVisible = signal(false);

  private ticking = false;

  constructor() {
    if (!this.isBrowser) {
      return;
    }

    const onScroll = () => {
      if (this.ticking) {
        return;
      }

      this.ticking = true;

      requestAnimationFrame(() => {
        this.isVisible.set(window.scrollY > SCROLL_THRESHOLD);
        this.ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    this.destroyRef.onDestroy(() => {
      window.removeEventListener('scroll', onScroll);
    });
  }

  protected scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
